import endpoints from '@/constants/endpoints';
import axiosV2 from '@/data/api/axiosv2';

import {
  AdminSignInResponse,
  SellerSignInResponse,
  SignInRequest,
} from '@/data/api/model/signIn/SignInDto';

export const requestAdminLoginApiV2 = async (body: SignInRequest) => {
  const response: AdminSignInResponse = await axiosV2.post(
    endpoints.auth.loginAdminApiV2,
    body
  );
  return response;
};

export const requestSellerLoginApiV2 = async (body: SignInRequest) => {
  const response: SellerSignInResponse = await axiosV2.post(
    endpoints.auth.loginSellerApiV2,
    body
  );
  if (!response.business_id) throw Error('Invalid Business Id');
  return response;
};
